export const HeaderRoutes = [
  {
    title: "Home",
    href: "/",
  },
  {
    title: "About",
    href: "#section-about",
  },
  {
    title: "Experience ",
    href: "#section-exp",
  },
  {
    title: "Skills",
    href: "#section-skills",
  },
  {
    title: "Portfolio",
    href: "#section-portfolio",
  },
  {
    title: "Contact",
    href: "#section-contact",
  },
];
